import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { R_ANALYTICS, R_GENERAL, R_SETTING, R_SPECIAL } from "../../text-data";
const ReviewTopNav = () => {
  
  const navigate = useNavigate();
const location = useLocation();
  const icons = [
    // Define your icon data here
    { label: R_GENERAL, navigateTo: "/review?time=IN_1_WEEKS" },
    { label: R_SPECIAL, navigateTo: "/review/special?time=IN_1_WEEKS" },
    { label: R_SETTING, navigateTo: "/review/setting" },
    { label: R_ANALYTICS, navigateTo: "/review/analytics" },
  ];
const index = icons.findIndex(icon => location.pathname.endsWith(icon.navigateTo.split('?')[0]));
  const [activeIndex, setActiveIndex] = useState(index > 0 ? index : 0); // Initial active index
  const handleClick = (index) => {
    navigate(icons[index].navigateTo);
    setActiveIndex(index);
  };

  return (
    <div className="top-nav-container">
      <ul className="top-nav-list">
        {icons.map((item, index) => (
          <li
            key={index}
            className={`top-nav-item ${activeIndex === index ? "active" : ""}`}
            onClick={() => handleClick(index)}
          >
            <span className={`top-nav-label`}>{item.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ReviewTopNav;
